import { put } from 'redux-saga/effects';
import i18next from 'i18next';

import api from './../api';
import { userFetchSuccess, userFetchFail, userSaveSuccess, userSaveFail, toastrAdd } from '../actions';

export function* userFetchSaga(action) {
  try {
    const response = yield api.user.getUser(action.userID);

    if (!response.data.data.user) {
      throw new Error('error in response');
    }
    yield put(userFetchSuccess(response.data.data.user));
  } catch (error) {
    console.log(error);
    yield put(userFetchFail(error));
  }
}

export function* userSaveSaga(action) {
  try {
    const response = yield api.user.saveUser(action.userID, action.data);

    if (!response.data.data.user) {
      throw new Error('error in response');
    }
    yield put(toastrAdd({details: i18next.t('users.save_success_details'), title: i18next.t('users.save_success_title'), type: 'success'}));
    yield put(userSaveSuccess(response.data.data.user));

  } catch (error) {
    console.log(error);
    yield put(toastrAdd({code: 0, details: `${i18next.t('general.details')}: ${error.errors[0].details}`, title: i18next.t('errors.general_form_error_title'), type: 'error'}));
    yield put(userSaveFail(error));
  }
}